import { render, staticRenderFns } from "./NearBy.vue?vue&type=template&id=10b8d806"
import script from "./NearBy.vue?vue&type=script&lang=js"
export * from "./NearBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/vercel/path0/components/common/Button.vue').default})
